import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import DataTable from '../../components/datatable'
import {
  PAGINATION_DEFAULT,
  employeeHrStatusConfig,
  employeeStatusConfig,
} from '../../utils/constants'
import { AllCountries } from '../../constants/countries'
import Button from '../../components/button'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { useGetEmployees } from '../../redux/admin/hook'
import UnauthorizedPage from '../errors/unauthorized'

const EmployeeManagement = () => {
  const { user } = useSelector((state) => state.userSlice)
  const history = useHistory()
  const [pagination, setPagination] = useState({
    limit: PAGINATION_DEFAULT.limit,
    page: PAGINATION_DEFAULT.page,
    statusFilter: PAGINATION_DEFAULT.statusFilter,
    search: '',
    country: '',
  })
  const [tableType, setTableType] = useState('table')
  const { refetch, data: employees } = useGetEmployees(
    pagination?.limit,
    pagination?.page,
    pagination?.statusFilter,
    pagination?.search,
    pagination?.country
  )
  const switchFunction = () => {
    if (tableType === 'employee') {
      setTableType('table')
    } else {
      setTableType('employee')
    }
  }
  const tableConfig = {
    headers: [
      'Name',
      'Email',
      'Mobile',
      'Date employed',
      'Payroll Group',
      'Status',
      'HR Status',
    ],
    keys: [
      'employeeName',
      'email',
      'mobile',
      'date_joined',
      'group_name',
      'status',
      'hr_status',
    ],
    mobileHeader: {
      left: {
        title: 'Employee Name',
        key: 'employeeName',
      },
      right: {
        title: 'Status',
        key: 'status',
      },
    },
  }

  async function Continue(id, type) {
    let index = employees.data.findIndex((item) => item.id === id)
    if (index !== -1) {
      if (type === 'view') {
        history.push('/employees/view/' + employees.data[index].id)
      }
    }
  }

  const actionConfig = [
    {
      name: 'View',
      color: 'orange',
      action: (id) => {
        Continue(id, 'view')
      },
    },
  ]

  return (
    <main className='flex flex-col gap-2.5'>
      <div className='flex flex-col bg-white rounded border'>
        <div className='flex flex-col md:flex-row justify-between items-center px-4 gap-[10px] my-2 mt-3'>
          <div className='md:flex hidden md:justify-start justify-center p3-bold header-4 md:w-[25%] w-full'>
            Employees
          </div>
          <div className='flex flex-col md:flex-row items-start gap-[10px] md:justify-end md:w-[75%] w-full'>
            {user?.company?.employee?.permission_employee_write === 1 && (
              <div className='md:w-fit w-[100%]'>
                <Button
                  text='New Employee(s)'
                  type='button'
                  theme='primary'
                  className='flex gap-2 !h-[35px] md:w-fit w-full px-2 items-center'
                  textClass={'!text-[11px]'}
                  leftIcon={'add'}
                  onClick={() => {
                    history.push('/employees/onboarding/select-option')
                  }}
                />
              </div>
            )}
            {user?.company?.employee?.permission_employee_read === 1 && (
              <div className='md:w-fit w-[100%]'>
                <Button
                  text='Refresh Table'
                  type='button'
                  theme='primary'
                  className='flex gap-2 !h-[35px] md:w-fit w-full px-2 items-center'
                  textClass={'!text-[11px]'}
                  onClick={() => {
                    refetch()
                  }}
                />
              </div>
            )}
          </div>
        </div>
        <hr className='divider mt-2 mb-1' />
        {user?.company?.employee?.permission_employee_read === 1 ? (
          <DataTable
            data={employees}
            tableConfig={tableConfig}
            statusConfig={employeeStatusConfig}
            actionConfig={actionConfig}
            updatePagination={(data) => setPagination(data)}
            filterByStatus={true}
            computedActions={true}
            tableType={tableType}
            showProfile={true}
            switchFunction={switchFunction}
            layoutSwitch={true}
            hrStatusConfig={employeeHrStatusConfig}
            searchData={true}
            searchPlaceholder={'Search by employee name or staff ID'}
          />
        ) : (
          <UnauthorizedPage />
        )}
      </div>
    </main>
  )
}

export default EmployeeManagement
